// extracted by mini-css-extract-plugin
export default {"Container":"splash_Container__fXRhj","ContainerHidden":"splash_ContainerHidden__WK-RD","logoWrapper":"splash_logoWrapper__jq0fv","glow":"splash_glow__s+z0y"};